// Mobile feed list/grid preference. Read uncached (not via getCookie) so it can't go stale mid-session.

const COOKIE_NAME = "mobile_feed_view"
const MAX_AGE_SECONDS = 60 * 60 * 24 * 30 // 30 days
const ALLOWED_VIEWS = ["list", "grid"]

export function getFeedViewPreference() {
  const prefix = `${COOKIE_NAME}=`
  const entry = document.cookie.split("; ").find((cookie) => cookie.startsWith(prefix))
  const value = entry ? decodeURIComponent(entry.slice(prefix.length)) : null

  return ALLOWED_VIEWS.includes(value) ? value : null
}

export function setFeedViewPreference(view) {
  if (!ALLOWED_VIEWS.includes(view)) return

  const secure = window.location.protocol === "https:" ? "; Secure" : ""
  document.cookie = `${COOKIE_NAME}=${view}; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`
}
